import { createValidatePhoneNumber } from './hooks/createValidatePhoneNumber'
import { useValidatePhoneNumber } from './hooks/useValidatePhoneNumber'

import { form } from './../../../../formState'

import { useTexts } from './useTexts'

export function PhoneNumber() {
  const texts = useTexts()
  const validatePhoneNumber = useValidatePhoneNumber()

  form.useAddFieldValidation<'phoneNumber'>('phoneNumber', async (field, _formApi) => {
    const phoneNumberValidation = await createValidatePhoneNumber(
      texts,
      field.value,
      validatePhoneNumber,
    )
    return (
      phoneNumberValidation.phoneNumberRequiredError?.message ||
      phoneNumberValidation.phoneNumberFormallyValidError?.message ||
      phoneNumberValidation.phoneNumberValidError?.message
    )
  })

  return (
    <form.TextField
      label={texts.phoneLabel}
      validateOn="change"
      name="phoneNumber"
      autoFocus
      helperText={texts.phoneHelper}
    />
  )
}
